@if (this.contactDetail$ | async; as contactDetail) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md"></div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="contactDetail.referees"
            [tabViewName]="'referees'"
            />
          </div>
        </div>
      </div>
    </div>
  }
